// Window Scroll Handler

(function ($) {
	$(window).on('scroll', function () {});
})(jQuery);
